const prefix = 'ACCOUNT';

const TOGGLE_OVERDUE_PROMPT_SUCCESS = `${prefix}/TOGGLE_OVERDUE_PROMPT_SUCCESS`;

const UPDATE_USER_INFO_SUCCESS = `${prefix}/UPDATE_USER_INFO_SUCCESS`;

const VERIFY_SUCCESS = `${prefix}/VERIFY_SUCCESS`;

const SET_REDIRECT = `${prefix}/SET_REDIRECT`;

export {
  TOGGLE_OVERDUE_PROMPT_SUCCESS,
  UPDATE_USER_INFO_SUCCESS,
  VERIFY_SUCCESS,
  SET_REDIRECT
};
